import React from "react"

export const YelpLogo = ({className='w-[51px] h-[20px]'}: {className?: string;}) => {
    return <img src={'/yelp-logo.png'} alt="yelp logo" className={className} />
}